// extracted by mini-css-extract-plugin
export default {"pricingTable":"PricingTable_pricingTable__eBcxK","pricingTableImage":"PricingTable_pricingTableImage__D4UwJ"};